import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-24 pb-12 px-6">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-3xl shadow-xl">
        <h1 className="text-3xl font-extrabold text-slate-900 mb-6">Privacy Policy for KaamSetu</h1>
        
        <p className="text-slate-600 mb-4">Last updated: {new Date().toLocaleDateString()}</p>

        <p className="text-slate-600 mb-4">
          At KaamSetu, accessible from www.indlabour.xyz, one of our main priorities is the privacy of our visitors. 
          This Privacy Policy document contains types of information that is collected and recorded by KaamSetu and how we use it.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">1. Log Files</h2>
        <p className="text-slate-600 mb-4">
          KaamSetu follows a standard procedure of using log files. These files log visitors when they visit websites. 
          The information collected includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">2. Cookies and Web Beacons</h2>
        <p className="text-slate-600 mb-4">
          Like any other website, KaamSetu uses 'cookies'. These cookies are used to store information including visitors' preferences, 
          and the pages on the website that the visitor accessed or visited.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">3. Google DoubleClick DART Cookie</h2>
        <p className="text-slate-600 mb-4">
          Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors. 
          However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">4. Privacy Policies</h2>
        <p className="text-slate-600 mb-4">
          You may consult this list to find the Privacy Policy for each of the advertising partners of KaamSetu. 
          Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">5. Consent</h2>
        <p className="text-slate-600 mb-4">
          By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.
        </p>

        <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Contact Us</h2>
        <p className="text-slate-600 mb-4">
          If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
        </p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;